import { Color } from '../../TSTypes/button';
import { DESIGN_SYSTEM_COLORS } from '../../constants';

const PrimaryColor: Color = {
  outlined: {
    true: {
      state: {
        default: {
          color: DESIGN_SYSTEM_COLORS.grayscale['900'],
          backgroundColor: DESIGN_SYSTEM_COLORS.grayscale['0'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.grayscale['900']}`,
        },
        hover: {
          color: DESIGN_SYSTEM_COLORS.grayscale['0'],
          backgroundColor: DESIGN_SYSTEM_COLORS.purple['900'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.purple['900']}`,
        },
        active: {
          color: DESIGN_SYSTEM_COLORS.grayscale['0'],
          backgroundColor: DESIGN_SYSTEM_COLORS.grayscale['1000'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.grayscale['1000']}`,
        },
        focus: {
          color: DESIGN_SYSTEM_COLORS.grayscale['900'],
          backgroundColor: DESIGN_SYSTEM_COLORS.grayscale['0'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.grayscale['900']}`,
          boxShadow: `0px 0px 0px 0.2rem rgba(97, 30, 239, 0.2)`,
        },
        disabled: {
          color: DESIGN_SYSTEM_COLORS.grayscale['650'],
          backgroundColor: DESIGN_SYSTEM_COLORS.grayscale['350'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.grayscale['350']}`,
        },
      },
    },
    false: {
      state: {
        default: {
          color: DESIGN_SYSTEM_COLORS.grayscale['0'],
          backgroundColor: DESIGN_SYSTEM_COLORS.grayscale['900'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.grayscale['900']}`,
        },
        hover: {
          color: DESIGN_SYSTEM_COLORS.grayscale['0'],
          backgroundColor: DESIGN_SYSTEM_COLORS.purple['900'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.purple['900']}`,
        },
        active: {
          color: DESIGN_SYSTEM_COLORS.grayscale['0'],
          backgroundColor: DESIGN_SYSTEM_COLORS.grayscale['1000'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.grayscale['1000']}`,
        },
        focus: {
          color: DESIGN_SYSTEM_COLORS['0'],
          backgroundColor: DESIGN_SYSTEM_COLORS.grayscale['900'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.grayscale['900']}`,
          boxShadow: `0px 0px 0px 0.2rem rgba(97, 30, 239, 0.2)`,
        },
        disabled: {
          color: DESIGN_SYSTEM_COLORS.grayscale['650'],
          backgroundColor: DESIGN_SYSTEM_COLORS.grayscale['350'],
          border: `1px solid ${DESIGN_SYSTEM_COLORS.grayscale['350']}`,
        },
      },
    },
  },
};

export default PrimaryColor;
